import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { mobileAppUtil } from "../../util";
import CategoryCard from "../card/CategoryCard";
import Heading from '../heading/Heading';
import Wrapper from "../wrapper/Wrapper";
import MediaQuery from 'react-responsive';
import { useHistory } from "react-router-dom";
export var RetailAllCategoryCards = function RetailAllCategoryCards(props) {
  var _props$fields = props.fields,
      fields = _props$fields === void 0 ? {} : _props$fields,
      _props$layout = props.layout,
      proplayout = _props$layout === void 0 ? {} : _props$layout,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? function () {
    return "";
  } : _props$onClick;
  var _fields$items = fields.items,
      items = _fields$items === void 0 ? [] : _fields$items;

  var layout = _objectSpread({
    background: 'solid',
    padding: 'medium'
  }, proplayout);

  var cleanedCategories = items.filter(function (item) {
    return Boolean(item.isActive) && item.categories.length;
  });
  var isMobileApp = mobileAppUtil.isMobileApp();
  return Array.isArray(cleanedCategories) && /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout
  }, /*#__PURE__*/React.createElement(Container, {
    className: "cb-retail__category"
  }, Array.isArray(cleanedCategories) ? cleanedCategories.map(function (parentCategory) {
    return Array.isArray(parentCategory.categories) && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, !isMobileApp && /*#__PURE__*/React.createElement(MediaQuery, {
      minWidth: 990
    }, /*#__PURE__*/React.createElement("div", {
      className: "cb-type--center w-100 pt-6"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/shop/".concat(parentCategory.slug),
      className: "cb-type__link-simple"
    }, /*#__PURE__*/React.createElement(Heading, {
      level: "2",
      field: {
        value: parentCategory.displayName
      },
      className: "cb-card__category-title"
    })))), Array.isArray(parentCategory.categories) ? /*#__PURE__*/React.createElement(Row, {
      className: "cb-retail__orb-link--group"
    }, /*#__PURE__*/React.createElement(MediaQuery, {
      minWidth: 990
    }, parentCategory.categories.map(function (category) {
      return /*#__PURE__*/React.createElement(OrbLink, _extends({}, category, {
        onClick: onClick
      }));
    })), /*#__PURE__*/React.createElement(MediaQuery, {
      maxWidth: 991
    }, /*#__PURE__*/React.createElement(SingleCategory, _extends({}, props, {
      toRender: parentCategory
    })))) : null));
  }) : null));
};

var OrbLink = function OrbLink(props) {
  var categoryContentPagePath = props.categoryContentPagePath,
      displayName = props.displayName,
      _props$image = props.image,
      image = _props$image === void 0 ? {
    src: "",
    alt: ""
  } : _props$image,
      _props$onClick2 = props.onClick,
      onClick = _props$onClick2 === void 0 ? function () {
    return "";
  } : _props$onClick2,
      category = props.category;
  var history = useHistory();

  var linkClicked = function linkClicked(e) {
    onClick(e);
    history.push(categoryContentPagePath);
  };

  return /*#__PURE__*/React.createElement(Col, {
    lg: "2",
    sm: "6"
  }, /*#__PURE__*/React.createElement("a", {
    href: '#',
    onClick: linkClicked,
    className: "cb-retail__orb-link"
  }, /*#__PURE__*/React.createElement("img", {
    src: image === null || image === void 0 ? void 0 : image.src,
    alt: image === null || image === void 0 ? void 0 : image.alt
  }), /*#__PURE__*/React.createElement("p", null, displayName)));
};

var SingleCategory = function SingleCategory(props) {
  var toRender = props.toRender,
      isEditing = props.isEditing;

  var setModel = function setModel(toRender) {
    var _toRender$image, _toRender$image2;

    var model = {
      "image": {
        "value": {
          "src": ((_toRender$image = toRender.image) === null || _toRender$image === void 0 ? void 0 : _toRender$image.src) || '',
          "alt": (toRender === null || toRender === void 0 ? void 0 : (_toRender$image2 = toRender.image) === null || _toRender$image2 === void 0 ? void 0 : _toRender$image2.Alt) || toRender.displayName
        }
      },
      "title": {
        "value": toRender.displayName
      },
      link: {
        value: {
          'href': toRender.categoryContentPagePath.replace('/sitecore/content/crackerbarrel/brandsite/home', '')
        }
      }
    };
    return {
      image: model.image,
      media: model.image,
      link: model.link,
      title: model.title
    };
  };

  var model = setModel(toRender);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    className: "d-block cb-card--small"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: 4,
    md: "6",
    className: "cb-card__category-container ".concat(isEditing ? "cb-card--scEdit" : "")
  }, /*#__PURE__*/React.createElement(CategoryCard, _extends({
    model: model
  }, props))))));
};